import { render, staticRenderFns } from "./WinAward.vue?vue&type=template&id=5fed40e2&scoped=true&"
import script from "./WinAward.vue?vue&type=script&lang=js&"
export * from "./WinAward.vue?vue&type=script&lang=js&"
import style0 from "./WinAward.vue?vue&type=style&index=0&id=5fed40e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed40e2",
  null
  
)

export default component.exports